module.exports = __webpack_public_path__ + "img/route.72693451.svg";